// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1txw{display:flex}
._kqswh2mm{position:relative}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/pagination/dist/esm/internal/components/render-ellipsis.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,iBAAiB","sourcesContent":["._1e0c1txw{display:flex}\n._kqswh2mm{position:relative}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
